import { Controller } from "stimulus";
import "select2"
import {removeHtmlElementClass} from "../utils/utils";


export default class extends Controller {
    static targets = [ "sleevePrice", "casePrice" ];

    initialPrices = {
        sleeve: null,
        case: null
    }

    initialize() {
        this.initialPrices['sleeve'] = parseFloat(this.sleevePriceTarget.value);
        this.initialPrices['case'] = parseFloat(this.casePriceTarget.value);
    }

    handleSave() {
        if (parseFloat(this.sleevePriceTarget.value) !== this.initialPrices.sleeve || parseFloat(this.casePriceTarget.value) !== this.initialPrices.case)
            removeHtmlElementClass(document, "loading_overlay", "d-none");
    }
}